export default "__VITE_ASSET__DgkzuNAM__"